import { useState } from "react";

import Modal from "../Modal";
import Button from "../Button";
import { Text } from "../Type";
import styles from "./index.module.scss";

type PropsType = {
  lockName: string;
  lockRole: string | undefined;
  userRole: string | undefined;
  isSubmitted: boolean;
};

const ViewOnlyModal = ({ lockName, lockRole, userRole, isSubmitted }: PropsType) => {
  const [warningModalIsOpen, setWarningModalIsOpen] = useState(true);

  const handleClose = () => {
    setWarningModalIsOpen(false);
  };

  return (
    <>
      <Modal
        isOpen={warningModalIsOpen}
        title={!isSubmitted && (userRole === "Authorizer" || userRole === "Motion Support") && lockRole === "Sales Rep" ? "Notification" : "View-only Mode"}
        onClose={handleClose}
      >
        <div className={styles.content}>
          {isSubmitted &&
            <Text>
              The application has been submitted for signature. You can still review it but no changes can be made at this time.
            </Text>
          }
          {!isSubmitted && (userRole === "Authorizer" || userRole === "Motion Support") && lockRole !== "Sales Rep" &&
            <Text>
              <b>{lockName}</b> is currently editing this application. You can still review it but no changes can be made at this time.
            </Text>
          }
          {!isSubmitted && (userRole === "Authorizer" || userRole === "Motion Support") && lockRole === "Sales Rep" &&
            <Text>
              <b>{lockName}</b> is currently commenting on this application. You can still modify it as needed.
            </Text>
          }
          {!isSubmitted && userRole === "Sales Rep" && (lockRole === "Authorizer" || lockRole === "Motion Support") &&
            <Text>
              <b>{lockName}</b> is currently editing this application. You can still review and add comments to this form at this time.
            </Text>
          }
          {!isSubmitted && userRole === "Sales Rep" && lockRole === "Sales Rep" &&
            <Text>
              <b>{lockName}</b> is currently commenting on this application. You can still review and add comments to this form at this time.
            </Text>
          }
        </div>
        <div className={styles.modalButton}>
          <Button primary onClick={handleClose}>
            Continue
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default ViewOnlyModal;
